import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';

import {ReportProps} from '../Report.types';

import {BusinessBuilderCoachesContent} from './BusinessBuilderCoachesContent';
import reportPayload from './reportPayload';

export const BusinessBuilderCoachesReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      contentComponent={BusinessBuilderCoachesContent}
      contentProps={{loadingData, showRecordPopover}}
      title={tt('title', 'Business Builder Coaches')}
      description={tt(
        'description',
        'These are the Coaches whose FCV will contribute to your Business Builder Bonus this month.',
      )}
      isTopLineTitle={true}
    />
  );
};
